// import queryString from "query-string";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import Swal from "sweetalert2";

import channelUserApi from "../../../../apis/ChannelUser.api";
import {
	setChannelUser,
	setSnsChannelUser,
} from "../../../../redux/store/auth/authDuck";
import { setLoading } from "../../../../redux/store/common/commonDuck";
import ApiService from "../../../../utils/ApiService";

const { Kakao } = window;
const api = new ApiService();

const KakaoCall = () => {
	const history = useHistory();

	const dispatch = useDispatch();
	// const isLoading = useSelector(state => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const client_id = "e24e92c52be719943a33f611d6264924";
	// const client_id = process.env.REACT_APP_KAKAO_KEY;

	// const {search} = props.location; // 문자열 형식으로 결과값이 반환된다.
	const queryObj = queryString.parse(history.location.search?.replace("?", "")); // 문자열의 쿼리스트링을 Object로 변환
	const code = queryObj.code;
	// const code = props.location.search?.split("code=")[1]

	useEffect(() => {
		if (!Kakao?.isInitialized()) {
			// 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
			Kakao?.init(process.env.REACT_APP_KAKAO_KEY);
		}
		kakaoToken();
	}, []);

	const kakaoToken = async () => {
		setIsLoading(true);
		let param = {
			grant_type: "authorization_code",
			client_id: client_id,
			redirect_uri: `${process.env.REACT_APP_HOST}/together/channel/user/sns/kakao`,
			code: code,
		};
		const influencer_id = sessionStorage.getItem("influencer_id");
		const influencer_user_id = sessionStorage.getItem("influencer_user_id");

		const backPage = sessionStorage.getItem("backPage");

		const res = await api.kakaoToken(param);

		if (res.status === 200) {
			Kakao.Auth.setAccessToken(res.data.access_token);

			Kakao.API.request({
				url: "/v2/user/me",
				success: async (response) => {
					let kakaoAccount = response.kakao_account;
					// let replacePhone = kakaoAccount.phone_number
					//   ?.replace("-", "")
					//   .replace("-", "")
					//   .replace("+82 ", "0");
					//SNS 가입여부 판단
					let param = {
						provider: "kakao",
						provider_id: response.id,
						// influencer_id: influencer_user_id,
						// phone: kakaoAccount.phone_number ? "" : null,
					};
					let res = await channelUserApi.snsValid(param);
					if (res.code === 200) {
						const result = res.result;

						// 가입 시 로그인 처리
						if (result.is_valid === true) {
							localStorage.removeItem("accessToken");
							localStorage.removeItem("refreshToken");

							localStorage.setItem(
								"accessToken",
								res.result.tokenDto.accessToken
							);
							localStorage.setItem(
								"refreshToken",
								res.result.tokenDto.refreshToken
							);
							dispatch(setChannelUser(res.result.users));
							// dispatch(setUser(res.result.users));

							setIsLoading(false);
							const historyParam = {
								id: res.result.users?.id,
								influencer_id: influencer_user_id,
							};
							const historyRes = await channelUserApi.snsLoginHistory(
								historyParam
							);

							const userAgent = window.navigator?.userAgent;
							const userAgentData = window.navigator?.userAgentData;
							// const rsp = await axios.get('https://geolocation-db.com/json/');
							// if (rsp.status === 200) {
							const param = {
								user_id: res.result.users?.id ?? 1,
								device_id: userAgent?.replace("Mozilla/5.0", "")?.trim(),
								device_agent: userAgentData?.platform,
								// device_ip: rsp.data.IPv4,
							};
							const rsq = await channelUserApi.postChannelUserIp(param);
							if (rsq.code) {
								if (backPage) {
									history.replace(backPage);
									sessionStorage.removeItem("backPage");
								} else {
									history.replace(`/share/${influencer_id}`);
								}
							}
							// }
						} else {
							if (result.is_user_valid === true) {
								Swal.fire({
									customClass: "alert-custom",
									text: "이미 회원가입이 된 사용자입니다. 아이디 찾기를 진행해주세요.",
									confirmButtonText: "확인",
								}).then(() => {
									history.replace(
										`/together/channel/login?id=${influencer_id}`
									);
									setIsLoading(false);
								});
							} else {
								let snsUserInfo = {
									provider: "kakao",
									provider_id: response.id,
									gender: kakaoAccount.gender,
									phone_number: kakaoAccount.phone_number,
									birthday: kakaoAccount.birthday,
									birthyear: kakaoAccount.birthyear,
									profile_nickname: kakaoAccount.profile.nickname,
								};
								dispatch(setSnsChannelUser(snsUserInfo));
								history.push(
									`/together/channel/sns-signup?id=${influencer_id}`
								);
								setIsLoading(false);
							}
						}
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
							confirmButtonText: "확인",
						}).then(() => {
							history.replace(`/together/channel/login?id=${influencer_id}`);
							setIsLoading(false);
						});
					}
				},
				fail: function () {
					Swal.fire({
						customClass: "alert-custom",
						text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						history.replace(`/together/channel/login?id=${influencer_id}`);
						setIsLoading(false);
					});
				},
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				history.replace(`/together/channel/login?id=${influencer_id}`);
				setIsLoading(false);
			});
		}
	};
	return <></>;
};

export default KakaoCall;
